module.exports = __webpack_public_path__ + "img/fasttalk.76a04ff7.jpg";